import React from 'react';

import { useIntlReexport } from '../../../application/hooks/useIntlReexport';
import { scormMessages } from '../../../translates/scormMessages';
import { DefaultErrorOverlay, ZIndex } from '@ael/shared-components-library';

export const SafelyExitCourseOverlay = () => {
  const { formatMessage } = useIntlReexport();
  return (
    <ZIndex index={9999}>
      <DefaultErrorOverlay
        title={formatMessage(scormMessages.progressSaved)}
        description={formatMessage(scormMessages.closeSafely)}
        error={false}
      />
    </ZIndex>
  );
};
